
const Tab = function (props) {
    return (
      <li className={"nav-item " + (props.mobile ? "" : "col-3")}>
        <a className={"nav-link row " + (props.isActive ? "active" : "") } 
            id={"tab_"+props.id} 
            data-toggle="tab" 
            href={"#pane_"+props.id} 
            role="tab"
            aria-controls={"pane_"+props.id} 
            aria-selected={props.isActive}
            onClick={props.click}>
            <div className="col-11 col-md-8 tabTitle">
              <h3>{props.data.Title}</h3>
              <div>{props.data.MahalSubTitle}</div>
            </div>
        </a>
      </li>
    );
  }
export default Tab;


